import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📄 Clientes
 *
 * Reporte:
 * Catálogo general de clientes
 *
 * Filtros:
 * - Estado (requerido)
 * - Nombre (opcional)
 *
 * Backend esperado:
 *
 * activeStatus
 * name
 */
export const customerReportFilters: UniversalFilterConfig[] = [
  {
    name: "activeStatus",
    label: "Estado",
    type: "select",
    iconKey: "status",
  },
  {
    name: "name",
    label: "Nombre",
    type: "text",
    iconKey: "user",
  },
];